module.exports = __webpack_public_path__ + "static/media/BIOP.80856b55.png";